import { render, staticRenderFns } from "./giftPageSetting.vue?vue&type=template&id=5fcff74a&"
import script from "./giftPageSetting.vue?vue&type=script&lang=js&"
export * from "./giftPageSetting.vue?vue&type=script&lang=js&"
import style0 from "./giftPageSetting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fcff74a')) {
      api.createRecord('5fcff74a', component.options)
    } else {
      api.reload('5fcff74a', component.options)
    }
    module.hot.accept("./giftPageSetting.vue?vue&type=template&id=5fcff74a&", function () {
      api.rerender('5fcff74a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/giftActivity/giftPageSetting.vue"
export default component.exports